import React, { useState } from 'react';

import { Autocomplete, Chip, TextField, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const AutocompleteTags = ({ control, disabled, name, size = 'small' }) => {
    const { t } = useTranslation();
    const [inputValue, setInputValue] = useState('');
    const [localError, setLocalError] = useState('');
    const placeholderText = 'Ingresa un valor y presiona Enter o coma';

    const handleInputChange = (event, newInputValue, reason) => {
        if (reason !== 'reset') setInputValue(newInputValue);
    };

    const handleAddTag = (event, field) => {
        if (['Enter', ','].includes(event.key) && inputValue.trim()) {
            event.preventDefault();
            const newTag = inputValue.trim().replace(',', '');
            const currentTags = field.value || [];

            if (currentTags.includes(newTag)) {
                setLocalError('Este valor ya fue ingresado');
                return;
            }

            setLocalError('');
            field.onChange([...currentTags, newTag]);
            setInputValue('');
        }
    };

    const renderValue = (value, getItemProps) =>
        value.map((option, index) => {
            const { key, ...itemProps } = getItemProps({ index });
            return <Chip {...itemProps} label={option} key={key} />;
        });

    return (
        <Controller
            control={control}
            name={name}
            render={({ field }) => (
                <Autocomplete
                    disabled={disabled}
                    freeSolo
                    inputValue={inputValue}
                    multiple
                    onChange={(_, value) => field.onChange(value)}
                    onInputChange={handleInputChange}
                    options={[]}
                    renderInput={(params) => (
                        <Tooltip placement="top" title={placeholderText}>
                            <TextField
                                {...params}
                                disabled={disabled}
                                error={!!localError}
                                fullWidth
                                helperText={localError}
                                label={t('Value', { count: 2 })}
                                onKeyDown={(event) =>
                                    handleAddTag(event, field)
                                }
                                placeholder={placeholderText}
                            />
                        </Tooltip>
                    )}
                    renderValue={renderValue}
                    size={size}
                    value={field.value}
                />
            )}
        />
    );
};

AutocompleteTags.propTypes = {
    control: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
    name: PropTypes.string.isRequired,
    size: PropTypes.string,
};

export default AutocompleteTags;
